import { NavLink } from 'react-router-dom'
import { useState, useEffect } from 'react'
import './Nav.css'



export default function Nav() {

  const [menu, setMenu] = useState(false);

  const toggleMenu = (() => {
    setMenu(!menu)
    console.log(menu);
  })


  return (
    <div>
      <button className={`${menu ? 'disable' : 'menuBtn'}`} onClick={toggleMenu} > {">>"} </button>

      <div className={`nav ${menu ? 'showMenu' : ''}`}>
        <div className='links'>
          <button className='closeBtn' onClick={toggleMenu}>&times;</button>
          <NavLink className='nav-link' to='/'>Home</NavLink>
          <NavLink className='nav-link' to='/about'>About</NavLink>
          <NavLink className='nav-link' to='/projects'>Projects</NavLink>
          <NavLink className='nav-link' to='/contact'>Contact</NavLink>
        </div>
      </div>

    </div>
  )
}
